export default "__VITE_PUBLIC_ASSET__673c04d2__"